import { getFaqs_allFaqs_nodes } from '../../services/types/getFaqs'

export const menuState = {
  faqs: undefined as getFaqs_allFaqs_nodes[],
}
